var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-headful',{attrs:{"title":_vm.meta.title,"description":_vm.meta.description,"html":{ body: {id: _vm.$route.meta.id } },"lang":_vm.$route.meta.lang,"head":{
      'link[rel^=shortcut]': {href: _vm.meta.favicon},
      'link[rel=apple-touch-icon]': {href: _vm.meta.appleicon},

      'link[rel=canonical]': {href: _vm.meta.url},

      'meta[property^=og][property$=title]': {content: _vm.meta.title},
      'meta[property^=og][property$=image]': {content: _vm.meta.img},
      'meta[property^=og][property$=url]': {content: _vm.meta.url},
      'meta[property^=og][property$=description]': {content: _vm.meta.description},

      'meta[name^=twitter][name$=title]': {content: _vm.meta.title},
      'meta[name^=twitter][name$=image]': {content: _vm.meta.img},
      'meta[name^=twitter][name$=description]': {content: _vm.meta.description},

      'meta[name=author]': {content: _vm.meta.author},

      'link#preload-0': _vm.preload[0],
      'link#preload-1': _vm.preload[1],
      'link#preload-2': _vm.preload[2],
      'link#preload-3': _vm.preload[3],
      'link#preload-4': _vm.preload[4],
      'link#preload-5': _vm.preload[5],
      'link#preload-6': _vm.preload[6],
      'link#preload-7': _vm.preload[7],
      'link#preload-8': _vm.preload[8],
      'link#preload-9': _vm.preload[9],
    }}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }